<template>
    <div v-if="active" class="aha-gallery">
        <div class="close-btn" @click="closeBtn"></div>
        <div v-if="fullscreen" class="aha-navigation small">
            <div v-html="images[sIndex].caption"></div>
            <div class="aha-arrows">
                <span class="left" @click="prev"></span>
                <span class="right" @click="next"></span>
            </div>
        </div>
        <div class="aha-wrapper" :class="{ 'fullscreen': fullscreen }">
            <div v-for="(img, index) in images" :key="index" @click="sIndex = index; fullscreen = true" class="aha-thumb" :class="{active: index == sIndex}">
                <img :src="img.url" :alt="img.caption">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: Boolean,
        year: String,
        images: Array,
    },
    data() {
        return {
            sIndex: 0,
            fullscreen: false,
        }
    },
    methods: {
        closeBtn() {
            if(this.fullscreen) {
                this.sIndex = 0;
                this.fullscreen = false;
            } else {
                this.sIndex = 0;
                this.fullscreen = false;
                this.$emit('close');
            }
        },
        prev() {
            if(this.sIndex == 0) {
                this.sIndex = this.images.length - 1;
            } else {
                this.sIndex--;
            }
        },
        next() {
            if(this.sIndex == this.images.length - 1) {
                this.sIndex = 0;
            } else {
                this.sIndex++;
            }
        }
     }
}
</script>

<style lang="scss" scoped>
.aha-gallery {
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100vh;
  z-index:999;
  background:var(--bg);
  .aha-navigation {
      position:fixed;
      bottom:var(--lh);
      left:0;
      color:var(--color);
      z-index:999;
      padding:calc(0.5 * var(--lh));
      align-items: flex-end;
      width:100%;
      display:grid;
      grid-template-columns: 1fr auto 1fr;
      grid-gap: calc(0.5 * var(--lh));
      mix-blend-mode: difference;
      @media only screen and (max-width:768px) {
          grid-template-columns: 1fr;
          .aha-arrows {
            // order:-1;
            display:flex;
            justify-content: center;
            margin:var(--lh) 0;
            mix-blend-mode: difference;
          } 
      }
      
      .left, .right {
          cursor:pointer;
          user-select:none;
          width:calc(0.5 * var(--bs));
          height:calc(0.5 * var(--bs));
          position:relative;
          display:inline-block;
          border-left:var(--b) solid #fff;
          border-top:var(--b) solid #fff;
          transform:rotate(135deg);
          @media only screen and (max-width:768px) {
            width:calc(1.5 * var(--bs));
            height:calc(1.5 * var(--bs));
          }
      }
      .left {
          transform:rotate(315deg);
      }
  }
  .aha-wrapper {
      max-height:100%;
      overflow-y:auto;
      padding: calc(0.5 * var(--lh));
      display:grid;
      grid-template-columns: 1fr 1fr 1fr;
      @media only screen and (max-width:768px) {
          grid-template-columns: 1fr 1fr;
      }
      grid-gap: calc(0.5 * var(--lh));
      align-items:flex-start;
      &.fullscreen {
          display:block;
          padding:0;
          overflow:hidden;
          .aha-thumb {
              position:absolute;
              cursor:default;
              top:0;
              left:0;
              bottom:0;
              right:0;
              padding-bottom:0;
              display: none;
              &.active {
                  display:block;
              }
              img {
                @media only screen and (orientation: portrait) {
                    object-fit: contain;
                }
              }
          }
      }
      .aha-thumb {
          position:relative;
          padding-bottom:56.25%;
          cursor:pointer;
          img {
              position:absolute;
              top:0;
              left:0;
              right:0;
              height:100%;
              bottom:0;
              object-fit: cover;
              
          }
      }
  }
  .close-btn {
      position:fixed;
      top: var(--lh);
      z-index:999;
      left: var(--lh);
      cursor: pointer;
      width:calc(1 * var(--bs));
      height:calc(1 * var(--bs));
      mix-blend-mode: difference;
      @media only screen and (max-width:768px) {
        width:calc(3 * var(--bs));
        height:calc(3 * var(--bs));
      }
    &:after {
        user-select: none;
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        width: calc(1 * var(--bs));
        height: 0;
        border-top: var(--b) solid #fff;
        transform: rotate(45deg);
        @media only screen and (max-width:768px) {
            width:calc(3 * var(--bs));
        }
      }
      &:before {
        user-select: none;
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        transform: rotate(135deg);
        width: calc(1 * var(--bs));
        height: 0;
        border-top: var(--b) solid #fff;
        @media only screen and (max-width:768px) {
            width:calc(3 * var(--bs));
        }
      }
  }
}
</style>